<template>
  <div>
    <div class="main1" v-show="star">
      <div style="font-weight: bold;font-size: 24px;margin-bottom: 20px;">霍兰德职业兴趣测试题</div>
      <p>本问卷共90道题目，每道题目是一个陈述，请你根据自己的真实情况对这些陈述进行评价，如果符合实际情况就在相应的题目勾选‘是’，否则勾选‘否’，不要漏答。</p>
      <div class="flex">
        <div class="one" v-for="(item,index) in data">
          <div class="one_title">
            {{index+1}}.{{item.question}}
          </div>
          <div style="margin-top: 30px;">
            <el-radio-group v-model="item.answer">
              <el-radio label="1" style="width: 100px;" @change="change(item,1)">是</el-radio>
              <el-radio label="2" style=" width: 100px;" @change="change(item,2)">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <el-button type="primary" style="width: 200px;margin-top: 80px;" @click="submit">提交</el-button>
    </div>
    <div class="main" v-show="!star">
      <div class="banner">

        <div class="img_title">
          <span>霍兰德职业兴趣测试题</span>
        </div>
        <div class="img_little_title">
          <span>【霍兰德职业兴趣理论的定义】 </span>
        </div>
        <div class="img_text">
          <span>
            &nbsp;&nbsp;约翰·霍兰德（John Holland）是美国约翰·霍普金斯大学心理学教授，美国著名的职业指导专家。
            他于1959年提出了具有广泛社会影响的职业兴趣理论。认为人的人格类型、
            兴趣与职业密切相关，兴趣是人们活动的巨大动力，凡是具有职业兴趣的职业，
            都可以提高人们的积极性，促使人们积极地、愉快地从事该职业，且职业兴趣与人格之间存在很高的相关性。
            Holland认为人格可分为现实型、研究型、艺术型、社会型、企业型和常规型六种类型。
          </span>
        </div>
        <div class="img_button">
          <span>
            <a @click="star=true">开始测试</a>
          </span>
        </div>
      </div>
      <!--  中间内容   -->
      <div class="bg">
        <div>
          <span style="padding-top: 4px;border:5px solid #236DB8;"></span>
          <span
            style='padding-left: 10px;font-size: 20px; font-weight: bolder; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;'>六种类型</span>
        </div>
        <div class="row">
          <div class="col-md-8 padding-left-40">
            <div class="padding-top-20">
              <span class="type">社会型：(S)</span>
            </div>
            <p class="feature">共同特征：</p>
            <p class="font-size-16">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢与人交往、不断结交新的朋友、善言谈、愿意教导别人。
              关心社会问题、渴望发挥自己的社会作用。寻求广泛的人际关系，比较看重社会义务和社会道德。</p>
            <p class="feature">典型职业：</p>
            <p class="font-size-16">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢要求与人打交道的工作，能够不断结交新的朋友，从事提供信息、启迪、帮助、培训、
              开发或治疗等事务， 并具备相应能力。 如: 教育工作者（教师、教育行政人员），社会工作者（咨询人员、公关人员）。</p>
            <div class="padding-top-20">
              <span class="type">企业型：(E)</span>
            </div>
            <p class="feature">共同特征：</p>
            <p class="font-size-16">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;追求权力、权威和物质财富，具有领导才能。喜欢竞争、敢冒风险、有野心、抱负。
              为人务实，习惯以利益得失，权利、地位、金钱等来衡量做事的价值，做事有较强的目的性。 </p>
            <p class="feature">典型职业：</p>
            <p class="font-size-16">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢要求具备经营、管理、劝服、监督和领导才能，以实现机构、政治、社会及经济目标的工作，
              并具备相应的能力。如项目经理、销售人员，营销管理人员、政府官员、企业领导、法官、律师。</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" style="padding-left: 40px; ">
            <div style="padding-top: 20px;">
              <span style="color: #236DB8; font-size: 18px; font-weight: 600;">常规型：(C)</span>
            </div>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              共同特征：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;尊重权威和规章制度，喜欢按计划办事，细心、有条理，习惯接受他人的指挥和领导，自己不谋求领导职务。
              喜欢关注实际和细节情况，通常较为谨慎和保守，缺乏创造性，不喜欢冒险和竞争，富有自我牺牲精神。</p>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              典型职业：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢要求注意细节、精确度、有系统有条理，具有记录、归档、据特定要求或程序组织数据和文字信息的职业，
              并具备相应能力。 如：秘书、办公室人员、记事员、会计、行政助理、图书馆管理员、出纳员、打字员、投资分析员。 </p>
            <div style="padding-top: 20px;">
              <span style="color: #236DB8; font-size: 18px; font-weight: 600; ">实际型：(R)</span>
            </div>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              共同特征：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;愿意使用工具从事操作性工作，动手能力强，做事手脚灵活，动作协调。偏好于具体任务，不善言辞，
              做事保守，较为谦虚。 缺乏社交能力，通常喜欢独立做事。 </p>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              典型职业：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢使用工具、机器，需要基本操作技能的工作。对要求具备机械方面才能、体力或从事与物件、机器、
              工具、运动器材、 植物、动物相关的职业有兴趣，并具备相应能力。如：技术性职业（计算机硬件人员、摄影师、制图员、机械装配工），技能性职业（木匠、厨师、技工、修理工、农民、一般劳动）。</p>
            <div style="padding-top: 20px;">
              <span style="color: #236DB8; font-size: 18px; font-weight: 600; ">调研型：(I) </span>
            </div>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              共同特征：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;思想家而非实干家,抽象思维能力强，求知欲强，肯动脑，善思考，不愿动手。喜欢独立的和富有创造性的工作。
              知识渊博，有学识才能，不善于领导他人。考虑问题理性，做事喜欢精确，喜欢逻辑分析和推理，不断探讨未知的领域。 </p>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              典型职业：</p>
            <p style="font-size: 16px;">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢智力的、抽象的、分析的、独立的定向任务，要求具备智力或分析才能，并将其用于观察、估测、衡量、
              形成理论、最终解决问题的工作，并具备相应的能力。如科学研究人员、教师、工程师、电脑编程人员、医生、系统分析员。</p>
            <div style="padding-top: 20px;">
              <span style="color: #236DB8; font-size: 18px; font-weight: 600; ">艺术型：(A) </span>
            </div>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              共同特征：</p>
            <p style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;有创造力，乐于创造新颖、与众不同的成果，渴望表现自己的个性，实现自身的价值。
              做事理想化，追求完美，不重实际。具有一定的艺术才能和个性。善于表达、怀旧、心态较为复杂。 </p>
            <p style="padding-left: 30px; font-size: 16px; padding-top: 16px; font-weight: bolder;" class="feature">
              典型职业：</p>
            <p style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;喜欢的工作要求具备艺术修养、创造力、表达能力和直觉，并将其用于语言、
              行为、声音、颜色和形式的审美、思索和感受，具备相应的能力。不善于事务性工作。如艺术方面（演员、导演、艺术设计师、雕刻家、建筑师、摄影家、广告制作人），
              音乐方面（歌唱家、作曲家、乐队指挥），文学方面（小说家、诗人、剧作家）。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        marks: {
          0: '0',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        },
        star: false,
        data: [],
        EI: 0,
        SN: 0,
        TF: 0,
        JP: 0,
        radio: true,
        R: 0,
        A: 0,
        E: 0,
        S: 0,
        I: 0,
        C: 0,
      }
    },
    created() {
      this.$http.Holland().then(res => {
        this.data = res.data.list
        this.data.forEach(item => {
          item.answer = "0"
        })
        console.log(this.data)
      })
    },
    methods: {
      change(item, value) {
        if (value == 1) {
          if (item.key == 'R') {
            this.R++
          }
          if (item.key == 'A') {
            this.A++
          }
          if (item.key == 'E') {
            this.E++
          }
          if (item.key == 'S') {
            this.S++
          }
          if (item.key == 'I') {
            this.I++
          }
          if (item.key == 'C') {
            this.C++
          }
        }
        item.answer = value + ''
        this.$forceUpdate()

      },
      submit() {
        this.data.some(item => {
          if (item.answer == '0') {
            this.$message.warning('您还有题目没有做完!')
            this.radio = false
            return true;
          } else {
            this.radio = true
          }
        })
        if (this.radio != false) {
          let data = [{
            name: "A",
            value: this.A
          }, {
            name: "C",
            value: this.C
          }, {
            name: "E",
            value: this.E
          }, {
            name: "I",
            value: this.I
          }, {
            name: "R",
            value: this.R
          }, {
            name: "S",
            value: this.S
          }]
          data.sort((item1, item2) => {
            return item2.value - item1.value
          })
          let result = data.splice(0, 3).map(item => {
            return item.name;
          }).join(',').split(',');
          console.log(data)
          this.$router.push(`huolandeResult?result=${result}`)
          // this.$http.testHollandResult({
          //   result: result
          // }).then(res => {
          //   console.log(res)
          // })
        }

      },
      changeA(item) {
        console.log(item)
        item.score1 = 5 - item.score
        console.log(item.score1)
        this.$forceUpdate()
      },
      changeB(item) {
        item.score = 5 - item.score1
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    width: 1280px;
    margin: 0px auto 20px auto;
    justify-content: space-around;
  }

  .main1 {
    width: 1280px;
    margin: 20px auto;
    justify-content: space-around;
  }

  .one {
    width: 500px;
    margin: 20px 0;
    text-align: left;

    .one_title {
      font-weight: bold;
    }

    .options {
      margin: 15px 0 15px 0;
    }

    .options1 {
      margin: 25px 0 10px 0;
    }
  }

  .flex {
    justify-content: space-between;
  }

  .banner {
    width: 100%;
    margin-top: 0px;
    position: relative;
    height: 300px;
    background: url('../../assets/huolande1.png');
    overflow: hidden;
  }

  .bg {
    /*background: rgba(35,109,184,0.02);*/
    text-align: left;
    margin-top: 50px;
  }

  .img_title {
    margin-top: 20px;
  }

  .img_title span {
    font-size: 26px;
    color: #FFFFFF;
  }

  .img_little_title {
    margin: 20px 40px;
    text-align: left;
  }

  .img_little_title span {
    font-size: 20px;
    color: #FFFFFF;
  }

  .img_text {

    margin: 40px;
    text-align: left;
  }

  .img_text span {
    font-family: monospace;
    font-size: 15px;
    color: #FFFFFF;
    line-height: 25px;

  }

  .img_button {

    width: 120px;
    height: 44px;
    line-height: 44px;
    border: 1px solid white;
    border-radius: 5px;
    margin: 40px auto;
  }

  .img_button span a {
    cursor: pointer;
    font-size: 20px;
    color: #FFFFFF;
    text-decoration: none;
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .padding-top-20 {
    padding-top: 20px;
  }

  .type {
    color: #236DB8;
    font-size: 18px;
    font-weight: 600;
  }

  .feature {
    padding-left: 30px;
    font-size: 16px;
    padding-top: 16px;
    font-weight: bolder;
    margin-bottom: 20px;
  }

  .font-size-16 {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/view/test/huolande.vue